import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=74f225b6&scoped=true&"
import script from "./supplier.vue?vue&type=script&lang=js&"
export * from "./supplier.vue?vue&type=script&lang=js&"
import style0 from "./supplier.vue?vue&type=style&index=0&id=74f225b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f225b6",
  null
  
)

export default component.exports